export enum Messages {
  BALANCE_IN_STELLARS = 'Your balance in Stellars (STR) represents the assets you held on the old Stellar network. You can upgrade to the new Stellar network and exchange your STR for Lumens (XLM), which are valid on the current network.',
  NO_BALANCE_ENOUGH = "It looks like you don't have enough funds to upgrade your account. But you can still create a",
  USER_UPGRADED = 'Your account was upgraded to the new Stellar network!',
  MANAGER_LUMENS = 'Now you can manage your Lumens on the current Stellar network using your new account.',
  RECOVER_USERNAME_SUCCESS = 'Your username has been sent to your email address.',
  SESSION_TIMED_OUT = 'Your session timed out, please login again',
}
